(function (root) {
  'use strict';
  var COUPON = 'UYE20';

  function applications(cart) {
    if (!cart || typeof cart !== 'object') return [];
    var found = [];
    [cart.discount_applications, cart.cart_level_discount_applications].forEach(function (list) {
      if (Array.isArray(list)) found = found.concat(list);
    });
    if (Array.isArray(cart.items)) cart.items.forEach(function (item) {
      (Array.isArray(item.discount_allocations) ? item.discount_allocations : []).forEach(function (allocation) {
        if (allocation && allocation.discount_application) found.push(allocation.discount_application);
      });
    });
    return found.filter(function (item) { return item && item.title; });
  }

  function savingsCents(cart) {
    var original = Number(cart && cart.original_total_price);
    var finalPrice = Number(cart && cart.total_price);
    return Number.isFinite(original) && Number.isFinite(finalPrice) ? Math.max(0, original - finalPrice) : 0;
  }

  function appliedCodeFromCart(cart, code) {
    if (!cart || savingsCents(cart) <= 0) return false;
    var wanted = String(code || '').trim().toUpperCase();
    var discounts = applications(cart);
    if (!!wanted && discounts.some(function (item) {
      var type = String(item.type || '').toLowerCase();
      return (type === 'discount_code' || type === 'manual') &&
        String(item.title || '').trim().toUpperCase() === wanted;
    })) return true;
    // Ajax carts can expose a verified discount_codes entry without allocations.
    var verifiedCode = Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (item) {
      return item && item.applicable === true &&
        String(item.code || '').trim().toUpperCase() === wanted;
    });
    var competingAutomatic = discounts.some(function (item) {
      return String(item.type || '').toLowerCase() === 'automatic' &&
        /2\s*Urun\s*Avantaji/i.test(String(item.title || ''));
    });
    return !!wanted && !!verifiedCode && !competingAutomatic;
  }

  function offeredLabel(cart) {
    if (appliedCodeFromCart(cart, COUPON)) return COUPON;
    var discounts = applications(cart);
    var codeInUse = discounts.some(function (item) {
      var type = String(item.type || '').toLowerCase();
      return type === 'discount_code' || type === 'manual';
    }) || (Array.isArray(cart && cart.discount_codes) && cart.discount_codes.some(function (code) {
      return code && code.applicable === true;
    }));
    if (codeInUse) return null;
    // Shopify discount titles can be localized or omitted. Use the actual
    // 10% saving on 2+ items rather than comparing a campaign title string.
    // Never attribute a different or manual discount to this campaign.
    if (discounts.some(function (item) {
      return String(item.type || '').toLowerCase() !== 'automatic';
    })) return null;
    var original = Number(cart && cart.original_total_price);
    var saving = savingsCents(cart);
    var quantity = Number(cart && cart.item_count);
    var allowedRounding = Math.max(2, Math.min(10, Array.isArray(cart && cart.items) ? cart.items.length : 0));
    if (Number.isSafeInteger(original) && original > 0 &&
        Number.isSafeInteger(quantity) && quantity >= 2 && saving > 0 &&
        Math.abs(saving - Math.round(original * 0.1)) <= allowedRounding) {
      return '2+ urunde %10';
    }
    return null;
  }

  function classifyResult(before, after, code) {
    return appliedCodeFromCart(after, code) ? 'applied' : 'ineligible';
  }

  function cartUrl(action) {
    var route = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    if (route.charAt(route.length - 1) !== '/') route += '/';
    return route + action;
  }

  function previousCoupon(cart) {
    var codes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
    var matching = codes.find(function (item) {
      return item && item.applicable !== false && item.code &&
        String(item.code).toUpperCase() !== COUPON;
    });
    if (matching) return String(matching.code);
    var other = applications(cart).find(function (discount) {
      return String(discount.type || '').toLowerCase() === 'discount_code' &&
        String(discount.title || '').toUpperCase() !== COUPON;
    });
    return other ? String(other.title) : '';
  }

  function readCart() {
    return root.fetch(cartUrl('cart.js'), {cache: 'no-store', credentials: 'same-origin'})
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to retrieve cart');
        return response.json();
      });
  }

  function setCode(code) {
    return root.fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({discount: code})
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update coupon');
      return response.json();
    });
  }

  function isTr() {
    return !!(root.document && root.document.documentElement &&
      /^tr\b/i.test(String(root.document.documentElement.lang || '')));
  }

  function translate(tr, en) { return isTr() ? tr : en; }
  function status(message, state) {
    var box = root.document.getElementById('stitch-uye20-status');
    if (!box) return;
    box.hidden = false;
    box.dataset.state = state;
    box.textContent = message;
  }

  function updateCartView(cart) {
    var drawer = root.StitchCartDrawer;
    if (!drawer || !cart) return;
    if (typeof drawer.updateTotals === 'function') drawer.updateTotals(cart);
    if (typeof drawer.setManualCouponIntent === 'function' && appliedCodeFromCart(cart, COUPON)) {
      drawer.setManualCouponIntent(true, cart);
    }
  }

  function sync(cart) {
    if (!root.document || !cart) return;
    var card = root.document.getElementById('stitch-uye20-card');
    var applied = appliedCodeFromCart(cart, COUPON);
    if (card) {
      card.hidden = Number(cart.item_count || 0) <= 0;
      card.dataset.applied = applied ? 'true' : 'false';
      var heading = card.querySelector('.stitch-uye20-card__heading strong');
      var details = card.querySelector('p');
      if (heading) heading.textContent = applied
        ? translate('UYE20 indirimin aktif', 'Your UYE20 discount is active')
        : translate('İlk alışverişine %20 indirim fırsatı', 'First order? Discover a 20% offer');
      if (details) details.textContent = applied
        ? translate('İndirim sepet toplamına yansıtıldı.', 'Your discount is reflected in the cart total.')
        : translate('UYE20, seçili ürünlerde bir kez kullanılabilir.', 'UYE20 can be used once on selected products.');
      var button = root.document.getElementById('stitch-uye20-apply');
      if (button) {
        button.dataset.applied = applied ? 'true' : 'false';
        button.textContent = applied ? translate('UYE20 uygulandı', 'UYE20 applied')
          : translate("UYE20'yi Uygula", 'Apply UYE20');
        if (button.getAttribute('aria-busy') !== 'true') button.disabled = applied;
      }
    }
  }

  async function applyOffer() {
    var button = root.document.getElementById('stitch-uye20-apply');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status(translate('UYE20 kontrol ediliyor…', 'Checking UYE20…'), 'pending');
    try {
      var before = await readCart();
      if (appliedCodeFromCart(before, COUPON)) {
        updateCartView(before);
        sync(before);
        status(translate('UYE20 zaten uygulanmış.', 'UYE20 is already applied.'), 'success');
        return;
      }
      var existing = previousCoupon(before);
      var attempt = await setCode(COUPON);
      var after = await readCart();
      if (classifyResult(before, after, COUPON) === 'applied') {
        updateCartView(after);
        sync(after);
        var extra = Math.max(0, Number(before.total_price || 0) - Number(after.total_price || 0));
        if (extra > 0) {
          var currency = String(after.currency || 'TRY');
          var amount;
          try { amount = new Intl.NumberFormat(isTr() ? 'tr-TR' : 'en-US', {style: 'currency', currency: currency}).format(extra / 100); }
          catch (_) { amount = String((extra / 100).toFixed(2)) + ' ' + currency; }
          status(translate('UYE20 uygulandı · Ek kazanç: ' + amount, 'UYE20 applied · Extra saving: ' + amount), 'success');
        } else {
          status(translate('UYE20 uygulandı. Güncel tutar sepette.', 'UYE20 applied. See cart for updated total.'), 'success');
        }
      } else if (classifyResult(before, attempt, COUPON) === 'applied') {
        // POST succeeded, but GET was stale. Never undo an accepted code.
        updateCartView(after);
        sync(after);
        status(translate('UYE20 kabul edildi; sepet henüz güncellenmedi. Sayfayı yenileyin.', 'UYE20 was accepted; refresh the cart to see the updated price.'), 'pending');
      } else {
        // Revert an unsuccessful attempt to the earlier coupon (or no coupon).
        // Never erase a previously applied non-UYE20 code silently.
        await setCode(existing);
        var verified = await readCart();
        updateCartView(verified);
        sync(verified);
        status(translate('UYE20 uygulanamadı. Kod seçili ürünlerde bir kez kullanılabilir.', 'UYE20 could not be applied. It can be used once on selected items.'), 'unavailable');
      }
    } catch (error) {
      status(translate('UYE20 kontrol edilemedi. Sepetteki tutarı kontrol edin.', 'Unable to check UYE20. Please check the cart total.'), 'error');
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = button.dataset.applied === 'true';
    }
  }

  function init() {
    var button = root.document && root.document.getElementById('stitch-uye20-apply');
    if (!button || button.dataset.hzBound === 'true') return;
    button.dataset.hzBound = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      applyOffer();
    });
    readCart().then(sync).catch(function () { /* Leave eligibility unspecified. */ });
  }

  var api = {appliedCodeFromCart: appliedCodeFromCart, offeredLabel: offeredLabel,
    classifyResult: classifyResult, sync: sync, applyOffer: applyOffer, init: init};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root.document) {
    root.HanezzaUye20Offer = api;
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', init);
    else init();
  }
})(typeof window !== 'undefined' ? window : globalThis);
